import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

interface EmitChangeOwnerInteractionEvent {
  assetId?: string;
  subjectId?: string;
}

export function useEmitChangeOwnerInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ assetId, subjectId }: EmitChangeOwnerInteractionEvent) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.ShareModal,
        optionSelected: "change_owner",
        customTrackingFields: {
          subject_id: subjectId,
          asset_id: assetId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
